module.exports = __webpack_public_path__ + "static/media/CV-Soliman-Al-Halaby.d3a1d1dc.pdf";